import { ParentMenuProps } from "../../../types/sidebar-v2.type";
import JGoogleIcon from "../../JGoogleIcon/JGoogleIcon";
import { useLocation } from 'react-router-dom'
import { 
  Flex, 
  Heading, 
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";
import useSidebarV2 from "../useSidebarV2";
import sidebarV2Store from "../../../stores/sidebar-v2.store";
import SubMenuChild from "./SubMenuChild";
import SubMenuLabel from "./SubMenuLabel";

interface SubMenuComponentProps {
  parentMenu: ParentMenuProps 
}

export default function SubMenu(props: SubMenuComponentProps) {
  const { parentMenu } = props

  const location = useLocation()
  const { textColor, searchBarBackgroundColor } = useSidebarV2()
  const { reveal } = sidebarV2Store()

  const isActive = parentMenu.subMenus.find((x) => x.href === location.pathname)

  return (
    <Accordion allowMultiple>
      <AccordionItem border='none' padding='0px'>
        <h2>
          <AccordionButton padding='0px' borderRadius='8px'>
            {reveal
              ? <SubMenuLabel isActive={isActive !== undefined} parentMenu={parentMenu} />
              : <Popover 
                  placement="right-start" 
                  trigger="hover" 
                  closeOnBlur={false}
                >
                  <PopoverTrigger>
                    <Flex width='100%'>
                      <SubMenuLabel isActive={isActive !== undefined} parentMenu={parentMenu} />
                    </Flex>
                  </PopoverTrigger>
                  <PopoverContent 
                    backgroundColor='onBackground' 
                    color='background' 
                    borderRadius='8px' 
                    width='max-content'
                  >
                    <PopoverBody>
                      <SubMenuChild 
                        parentMenu={parentMenu} 
                        removeMarginLeft 
                        removePaddingTop 
                      />
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
            }
          </AccordionButton>
        </h2>
        <AccordionPanel padding='0px' display={reveal ? 'block' : 'none'}>
          <SubMenuChild parentMenu={parentMenu} />
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}
